import { inject } from '@angular/core';
import { CanDeactivateFn } from '@angular/router';
import { Observable } from 'rxjs';
import { ConfirmDialogService } from '@app/core/services/confirm-dialog.service';

export interface HasUnsavedChanges {
  hasUnsavedChanges(): boolean;
}

export const unsavedChangesGuard: CanDeactivateFn<HasUnsavedChanges> = (component): Observable<boolean> | boolean => {
  if (!component.hasUnsavedChanges()) return true;

  const confirmDialog = inject(ConfirmDialogService);
  return confirmDialog.confirm({
    title: 'unsavedChanges.title',
    message: 'unsavedChanges.message',
    confirmLabel: 'unsavedChanges.leave',
    cancelLabel: 'unsavedChanges.stay',
    confirmVariant: 'danger',
  });
};
